export const LIMIT_MAX = 99999
export const LIMIT_20 = 20
export const LIMIT_10 = 10
export const LIMIT_5 = 5
export const ALPHANUMERIC_WITH_DASH_DOT = "^[\\w \\-.]*$"
export const ALPHA_DIACRITIC_REGEXP = "^[\\w \\-().,&'#/~; \\p{L}+|\\p{M}+]*$"
export const CITY_REGEXP = "^[\\w \\-().,&'#/~; \\p{L}+|\\p{M}+]*$"
export const ADDRESS_REGEXP = "^[\\w \\-\\(\\).,'#&\\/~;: \\p{L}+\\|\\p{M}+]*$"
export const NAME_REGEXP = "^[\\w \\-\\(\\).,&'#\\/~;! \\p{L}+\\|\\p{M}+]*$"
export const USER_NAME_REGEXP = "^[\\w\\-_!#$%&'*+\\/`=?@.,\\p{L}+\\|\\p{M}+]*$"
export const EMAIL_REGEXP = "^[a-zA-Z0-9_!#$%&'*+\\/`=?\\{\\|\\}~^.\\-]+@[a-zA-Z0-9.\\-]+.[a-zA-Z]{2,63}$"
export const PASSWORD_REGEX = '^(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[0-9])(?=.*?[!-/:-@[-`{-~]).{12,255}$'
export const NUMBERS_ONLY_REGEX = '^(?=.*?[0-9]).{6,}$'
export const MIN_PASSWORD_CHARS = 12
export const MAX_PASSWORD_CHARS = 255
export const MIN_OTP_CHARS = 6
export const IMAUTH_API_V1 = 'imauth/api/v1'
export const ACCOUNT_UI_API_VI = 'account/ui-api/v1'
export const UPDATE_PASSWORD = 'UPDATE_PASSWORD'
export const DCONE_LOCALE_COOKIE_NAME = 'lang'
export const DCONE_LOGIN_ACTION_TOKEN = 'dcone.login.action.token'